var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 24.4609H35.64C33.68 24.4609 31.94 25.5409 31.06 27.3009L29.38 30.6209C28.98 31.4209 28.18 31.9209 27.3 31.9209H20.74C20.12 31.9209 19.24 31.7809 18.66 30.6209L16.98 27.3209C16.1 25.5809 14.34 24.4809 12.4 24.4809H5.4C4.62 24.4809 4 25.1009 4 25.8809V32.4009C4 39.6609 8.36 44.0009 15.64 44.0009H32.4C39.26 44.0009 43.48 40.2409 44 33.5609V25.8609C44 25.1009 43.38 24.4609 42.6 24.4609Z",
    fill: "#D8D5C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 15.62V21.7C43.56 21.54 43.08 21.46 42.6 21.46H35.64C32.54 21.46 29.76 23.18 28.38 25.94L26.88 28.9H21.16L19.66 25.96C18.28 23.18 15.5 21.46 12.4 21.46H5.4C4.92 21.46 4.44 21.54 4 21.7V15.62C4 8.34 8.34 4 15.62 4H32.38C39.66 4 44 8.34 44 15.62Z",
    fill: "#D8D5C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectNormal);
export default __webpack_public_path__ + "static/media/direct-normal.c31bf859f2091b70eaf87713c041f2e4.svg";
export { ForwardRef as ReactComponent };